import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const MinusButton = (props: SvgIconProps) => {
	return (
		<SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				id="Box"
				d="M20 24L4 24C1.79086 24 0 22.2091 0 20L0 4C0 1.79086 1.79086 0 4 0L20 0C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24Z"
				fill="#EA650D"
			/>
			<path
				id="+"
				d="M11.0131 12.8828H13.0081H16.7131V10.9448H13.0081L11.0131 10.9443L7.28906 10.9448V12.8828H11.0131Z"
				fill="white"
			/>
		</SvgIcon>
	);
};

